import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface IconProps {
  icon: LucideIcon;
  size?: number;
  className?: string;
  /** When set, the icon is announced with this label; otherwise it is decorative. */
  label?: string;
}

/** Renders a lucide icon, hidden from assistive technology unless it has a label. */
const Icon: React.FC<IconProps> = ({ icon: LucideComponent, size = 20, className, label }) =>
  label ? (
    <LucideComponent size={size} className={className} role="img" aria-label={label} focusable="false" />
  ) : (
    <LucideComponent size={size} className={className} aria-hidden="true" focusable="false" />
  );

export default Icon;
